import { type Query } from '@inpart-io/devtools-iap';
import { STORE_DATA_OBJECTS, UPDATE_DATA_OBJECT } from '@inpart-io/devtools-vue';
import { agreementDocumentProperties, DataType } from '@inpart-io/padme-iap';
import { amendmentsManager, type IAmendment, type IExternalLink } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { AGREEMENT_DOCUMENT_MODULE } from '../agreement-document-module';
import { UPLOAD_FILE_TO_OBJECT } from '../base/binary-uploads/actions';
import { AMENDMENT_MODULE } from '.';
import { RECEIVE_AMENDMENT_STATUS_AGGREGATION_BY_AGREEMENT } from './mutations';

export const COUNT_AMENDMENT_STATUS_BY_AGREEMENTS = 'countAmendmentStatusByAgreement';
export const CREATE_AMENDMENT = 'createAmendment';

export const actions: ActionTree<IAmendment, unknown> = {
    async [CREATE_AMENDMENT](
        context,
        { amendment, link, document, properties }: { amendment: IAmendment; link?: IExternalLink; document?: File; properties?: string }
    ): Promise<number> {
        const newAmendment = await amendmentsManager.createAmendmentWithAttachment(amendment, link, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [newAmendment] });
        if (document) {
            const newDocumentId = await context.dispatch(
                `${AGREEMENT_DOCUMENT_MODULE}/${UPLOAD_FILE_TO_OBJECT}`,
                {
                    objectId: amendment.agreementDetail,
                    objectType: DataType.AgreementDetail,
                    file: document,
                    links: [
                        {
                            type: DataType.Amendment,
                            dobjId: newAmendment.dobjId
                        }
                    ],
                    properties: agreementDocumentProperties.DEFAULT
                },
                { root: true }
            );
            await context.dispatch(
                `${AMENDMENT_MODULE}/${UPDATE_DATA_OBJECT}`,
                {
                    dataObjectList: [
                        {
                            dobjId: newAmendment.dobjId,
                            mainAttachment: { dobjId: newDocumentId, type: DataType.AgreementDocument }
                        }
                    ],
                    properties
                },
                { root: true }
            );
        }
        return newAmendment.dobjId;
    },
    async [COUNT_AMENDMENT_STATUS_BY_AGREEMENTS](context, { query, agreements = [] }: { query?: Query; agreements?: number[] }) {
        try {
            const aggregationResult = await amendmentsManager.countStatusByAgreement(query, agreements.length);
            context.commit(RECEIVE_AMENDMENT_STATUS_AGGREGATION_BY_AGREEMENT, { aggregationResult, agreements });
        } catch (error) {
            console.error(error);
            context.commit(RECEIVE_AMENDMENT_STATUS_AGGREGATION_BY_AGREEMENT, { aggregationResult: undefined });
        }
    }
};
